/**
 * Pure filter constants + types for the Projects module.
 *
 * Lives in its own file so `ProjectsFilterRail.tsx` only exports a
 * component (the React Fast Refresh contract). Same split as
 * `inventory-filters.ts` (Sprint 09) and `date-presets.ts` (Sprint 09
 * Margins rail).
 */

import type { ProjectStatus } from '../api/types'

/** "all" overlays the union with a sentinel for the chip group; the
 *  network call sends `status` only when StatusFilter !== 'all'. */
export type StatusFilter = 'all' | ProjectStatus

export const STATUS_FILTER_OPTIONS: { value: StatusFilter; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'draft', label: 'Draft' },
  { value: 'testing', label: 'Testing' },
  { value: 'approved', label: 'Approved' },
  { value: 'rejected', label: 'Rejected' },
]
